import { Link } from 'react-router-dom';

export default function CasesFooter() {
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <img
            src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png"
            alt="NeuroAgents Global AI"
            className="h-12 w-auto mx-auto mb-4"
          />
          <p className="text-gray-400 text-sm whitespace-nowrap">Global AI Automation</p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <h4 className="text-white font-bold mb-4 whitespace-nowrap">Navegação</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#10B981] transition-colors text-sm whitespace-nowrap cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/casos-de-sucesso" className="text-gray-400 hover:text-[#10B981] transition-colors text-sm whitespace-nowrap cursor-pointer">
                  Casos de Sucesso
                </Link>
              </li>
              <li>
                <a href="/#planos" className="text-gray-400 hover:text-[#10B981] transition-colors text-sm whitespace-nowrap cursor-pointer">
                  Planos
                </a>
              </li>
              <li>
                <Link to="/termos-de-uso" className="text-gray-400 hover:text-[#10B981] transition-colors text-sm whitespace-nowrap cursor-pointer">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/politica-de-privacidade" className="text-gray-400 hover:text-[#10B981] transition-colors text-sm whitespace-nowrap cursor-pointer">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 whitespace-nowrap">Redes Sociais</h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/neuroagentsglobal"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-[#10B981] rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://wa.me/5541992584018"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-[#10B981] rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 whitespace-nowrap">Contato</h4>
            <p className="text-gray-400 text-sm mb-2">
              <strong className="text-white">Email:</strong> contato@neuroagents.com.br
            </p>
            <p className="text-gray-400 text-sm">
              <strong className="text-white">WhatsApp:</strong>{" "}
              <a 
                href="https://wa.me/5541992584018"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#10B981] transition-colors cursor-pointer"
              >
                (41) 99258-4018
              </a>
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © 2025 NeuroAgents Global AI. Todos os direitos reservados.
          </p>
          <p className="text-gray-600 text-xs mt-2">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
